window.app_models.placement_contact = {
    id:null,
    placement_id:null,
    placement_contact_type_id:null,
    sales_rep_id: null,
    housing_coordinator_id: null,
    status_coordinator_id: null,
    position: null,
    type:null,
    contact:window.app_models.contact,
    contact_data:window.app_models.contact,
    company:window.app_models.company,
    company_data:window.app_models.company,
    hub_email: "",
    placement_contact_type: window.app_models.option
};



// WEBPACK FOOTER //
// ./resources/assets/js/models/placement_contact.js